<template>
  <a href="" :class="'cart__btn btn' + ' btn--' + $store.getters['auth/role']" @click.prevent="validCart">
    <span class="btn__text">Je valide mon panier</span>
    <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
  </a>
</template>

<script>


export default {
  name: "CartValid",
  props: ['comment'],
  data() {
    return {
    }
  },
  created() {

  },
  methods:{
    // Méthode qui valide le panier > passe la commande en statut commande créée
    validCart(){
      const self = this;

      // Affichage du loader
      this.$store.dispatch('showCartLoader');

      // Récupération du panier pour l'envoyer au back
      let cart = this.$store.getters["order/getMyCart"];

      // Ajout du commentaire
      cart.comment = this.comment

      let productsInUnavailableQuantity = 0;

      // On compte le nombre de produits dont la quantité au panier est supérieure à celle du stock
      for(var i=0; i< cart.lines.length; i++){
        if(cart.lines[i].quantity > cart.lines[i].product.product_shops[0].stock){
          productsInUnavailableQuantity ++;

          // Message d'erreur
          self.$toastr.error('Le produit <strong>' + cart.lines[i].product.label + '</strong> n\'est pas en quantité suffisante dans le magasin');
        }
      }

      if(productsInUnavailableQuantity == 0){

        // Requête AJAX : passage de l'id du panier qui correspond
        // à un id de commande (mci_order) côté back.
        // La commande passe du statut -1 au statut 2
        this.$http.patch('order/cart/valid/'+cart.id, cart).then(response => {

          // Récupération du panier à jour (il est normalement vide car la commande n'est plus en statut panier)
          this.$store.dispatch("order/getMyCart").then(function(){

            let cart = self.$store.getters["order/getMyCart"];

            // On cache le loader du panier
            self.$store.dispatch('hideCartLoader');

            // Message de succès
            self.$toastr.success(self.$i18n.t("success.cart.validated"));

            // Callback de succès
            self.$emit('success')

            self.$store.dispatch("order/getMyOrders").then(() => {
              self.$router.push({ name: "OrderList" });
            });

          });
        }).catch(error => {
          // Récupération du panier à jour (il est normalement vide car la commande n'est plus en statut panier)
          self.$store.dispatch("order/getMyCart").then(function(){

            let cart = self.$store.getters["order/getMyCart"];

            // On cache le loader du panier
            self.$store.dispatch('hideCartLoader');
          });
        })
      }else{

        // On cache le loader du panier
        self.$store.dispatch('hideCartLoader');
      }
    }
  },
  computed: {

  },
  mounted() {

  }
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.cart__btn {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  height: 75px;
  color: white;
  background-color: $vert;
  outline: none;
  border-radius: 0;
  outline: none;

  img {
    width: 25px;
    margin-left: 5px;
  }

  span {
    font-size: 12px;
    font-family: 'ClanProBold';
  }
}

@media screen and (max-width: 450px) {
  .btn {
    &--ROLE_TECHNICIAN {
      span {
        width: 82px;
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/CartValid.vue